import { render, staticRenderFns } from "./lsdds.vue?vue&type=template&id=ed8dd3c4&scoped=true"
import script from "./lsdds.vue?vue&type=script&lang=js"
export * from "./lsdds.vue?vue&type=script&lang=js"
import style0 from "./lsdds.vue?vue&type=style&index=0&id=ed8dd3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8dd3c4",
  null
  
)

export default component.exports